import {AccessManagementConfig, commonAccessManagementConfig} from '@scalified-monorepo/shared/casl';
import {SampleAppAbilities} from './abilities';

export const sampleAccessManagementConfig: AccessManagementConfig<SampleAppAbilities> = {
  ...commonAccessManagementConfig,
  Account: {
    actions: ['create', 'read', 'update', 'delete', 'assignRole'],
    fields: [
      {name: 'id', type: 'id'},
      {name: 'email', type: 'email'},
      {name: 'tenantId', type: 'id'},
      {name: 'firstName', type: 'string'},
      {name: 'lastName', type: 'string'},
      {name: 'language', type: 'string'},
      {name: 'country', type: 'string'},
      {name: 'verified', type: 'boolean'},
      {name: 'hasPassword', type: 'boolean'},
      {name: 'roles', type: 'string'},
      {name: 'createdAt', type: 'date'},
    ],
  },
};
